const getters = {
    headerBreadcrumbs: (state) => {
        return state._headerBreadcrumbs;
    },
};

export default getters;
